import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject, merge } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { PhoneBook, AADUsers } from '../models/data.model';
import { CommonService } from '../services/common.service';
import { DataService } from '../services/data.service';

const states = ['Alabama', 'Alaska', 'American Samoa', 'Arizona', 'Arkansas', 'California', 'Colorado',
  'Connecticut', 'Delaware', 'District Of Columbia', 'Federated States Of Micronesia', 'Florida', 'Georgia',
  'Guam', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine',
  'Marshall Islands', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana',
  'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota',
  'Northern Mariana Islands', 'Ohio', 'Oklahoma', 'Oregon', 'Palau', 'Pennsylvania', 'Puerto Rico', 'Rhode Island',
  'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virgin Islands', 'Virginia',
  'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];

@Component({
  selector: 'app-phone-book',
  templateUrl: './phone-book.component.html',
  styleUrls: ['./phone-book.component.css']
})
export class PhoneBookComponent implements OnInit {

  phoneBookList: PhoneBook[] = [];
  companies: any[] = [];
  model:any;
  utenti:AADUsers[]=[];

  @ViewChild('instance') instance: NgbTypeahead;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  formatter = (x: { displayName:string }) => x.displayName;
  srch:PhoneBook=null;
  

  //@Input() name: string;

  constructor(
    public activeModal: NgbActiveModal,
    private dataService: DataService,
    private aadService:CommonService<AADUsers>
    ) { }

  ngOnInit() {
    //console.log(this.name);
    //this.mockData();
    this.getUsers();
    //this.utenti = [];
    
  }

  public ngAfterViewInit() {
    //this.getUsers();
  }

  getUsers = () =>{
    let url = 'api/rest/getAADUsers';      
    let params = { params: {} };
    //this.utenti = this.aadService.getData(url,params,false) as Observable<Array<AADUsers>>;
    this.aadService.getData(url,params,false).subscribe(result=>{
      this.utenti = result as AADUsers[];
      this.utenti = this.utenti.filter(x=> x.givenName);
      this.utenti.forEach((x)=>{
        x.id = null;
      });
      console.log("this is list of users : ",this.utenti);
    });
  }

  mockData = () => {
    this.phoneBookList = [
      {
        fName: "Gerard",
        lName: "Burgstede",
        mail: "gerard.burgstede@3mensio.com",
        tel: "+31 30 2740003",
        company: "3mensio Medical Imaging BV",
        photo: "./assets/images/employee-male.png"
      },
      {
        fName: "Jan",
        lName: "De Vaan",
        mail: "janv@3mensio.com",
        tel: "+31 30 2740005",
        company: "3mensio Medical Imaging BV",
        photo: "./assets/images/employee-male.png"
      },
      {
        fName: "Giulia",
        lName: "Accinni",
        mail: "giulia.accinni@ebit.it",
        tel: "+39 010-6547591",
        company: "Ebit s.r.l.",
        photo: "./assets/images/employee-female.png"
      },
      {
        fName: "Alberto",
        lName: "Berruti",
        mail: "alberto.berruti@ebit.it",
        tel: "+39 335-6602130",
        company: "Ebit s.r.l.",
        photo: "./assets/images/employee-male.png"
      },
    ]
  }

  search = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
    const inputFocus$ = this.focus$;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term => (term === '' ? this.utenti
        : this.utenti.filter(v => v.displayName.toLowerCase().indexOf(term.toLowerCase()) > -1)).slice(0, 10))
    );
  }

  filterPhoneBook = (r) =>{
    this.srch = r;
    console.log(this.srch);
  }

  public trackByFn(index,item){
    if(!item) return null;
    return index;
  } 

}
